import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'components/Luxkit/Button/TextButton'
import BodyText from 'components/Luxkit/Typography/BodyText'
import React, { useCallback, useContext, ReactElement } from 'react'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyLoungePassBenefitsModal from './LandingPageLoyaltyLoungePassBenefitsModal'

const image: App.Image = {
  id: 'rq13k5lzgr8oxoz3a2',
  title: 'Free airport lounge passes',
}

interface Props {
  tier: App.LoyaltyTier
  benefit: App.LoyaltyBenefit
  benefitLabel: ReactElement
}

function LandingPageLoyaltyLoungePass(props: Props) {
  const { tier, benefit, benefitLabel } = props
  const showModal = useContext(ModalContext)

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyLoungePassBenefitsModal
      image={image}
      tier={tier}
      numberOfBenefitRemaining={benefit.remaining ?? 0}
    />)
  }, [showModal, tier, benefit])

  return <LandingPageLoyaltyBenefitTile
    heading="Free airport lounge passes"
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" onClick={handleDetailsClick}>
      Details
    </TextButton>}
  >
    <BodyText variant="medium">
      Kick off your trip in comfort with complimentary access to select airport lounges across Australia. Recharge with a drink, a bite to eat, and space to relax before your flight.
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyLoungePass
